import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[redMetabaseParameterContainer]',
})
export class MetabaseParameterContainerDirective {
  constructor(public viewContainerRef: ViewContainerRef) {}
}
